module.exports = __webpack_public_path__ + "static/media/brandLogo.65a6b82f.png";